declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbIdentitiesinfoModal } from './modals/identitiesinfo.modal'
import { ActorIdentitiesController } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { ActorIdentitiesPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { DOCService } from '../../../../services/doc.service';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController } from '../../../../models/actor/actor';
@Component({
  selector: 'driverinfov3',
  templateUrl: './driverinfov3.component.html',
  styleUrls: ['./driverinfov3.component.scss']
  , animations: [routerTransition()]
})

export class DriverInfoV3Component implements OnInit {
  DL: ActorIdentitiesController;
  Passport: ActorIdentitiesController;
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  CurrentActorIdentitiesRequest: ActorIdentitiesRequest;
  CurrentActorIdentitiesController: ActorIdentitiesController[];
  Dls: ActorIdentitiesController[];
  Pps: ActorIdentitiesController[];
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;


  constructor(private router: Router, private docservice: DOCService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private actoridentitiespipe: ActorIdentitiesPipe,
    private modalService: NgbModal, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.CurrentActorIdentitiesRequest = new ActorIdentitiesRequest();
    this.CurrentActorIdentitiesController = new Array<ActorIdentitiesController>();
    this.CurrentActorIdentitiesRequest.ActorCode = this.ActorCode;
      //AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorIdentitiesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorIdentitiesController();
    }

  }

  GetActorIdentitiesController() {
    this.StartRefreshing();
    this.actorservice.GetActorIdentitiesController(this.CurrentActorIdentitiesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
        //  console.log('this.ApiResData.Result-->' + this.ApiResData.Result.length);
          this.CurrentActorIdentitiesController = this.ApiResData.Result;
          //this.initGridButton();


          /// 100 % two records will be there
        
          this.LoadDriversLicense();



          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  LoadDriversLicense() {
    // load driver's license..
    for (let l of this.CurrentActorIdentitiesController) {
      
      if (l.CredentialType == "Driver's License") {
        this.DL = l;
        this.Dls = new Array<ActorIdentitiesController>();
        this.Dls.push(this.DL);
        {
          //this.GetDLDocs(this.DL.ActorDocCode);          
        }
        
      }
      
      if (l.CredentialType == 'Passport') {
        this.Passport = l;
        this.Pps = new Array<ActorIdentitiesController>();
        this.Pps.push(this.Passport);
        {
          //this.GetPassportDocs(this.Passport.ActorDocCode);             
        }
      }        
    }

  }
  LoadPassport() {
    for (let l of this.CurrentActorIdentitiesController) {
      if (l.CredentialType == 'Passport') {
        this.Passport = l;
        this.Pps = new Array<ActorIdentitiesController>();
        this.Pps.push(this.Passport);
        {
        //  this.GetPassportDocs(this.Passport.ActorDocCode);
          break;
        }
      }
    }
  }
  GetPassportDocs(ActorDocCode: number) {


    this.CurrentActorPPDocRequest = new ActorDocRequest();
    this.CurrentActorPPDocRequest.EntryActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorPPDocRequest.ActorDocCode = ActorDocCode;
    this.CurrentActorPPDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorPPDocController = new Array<ActorDocController>();

    this.GetActorPPDocController();
  }
  GetDLDocs(ActorDocCode: number ) {


    this.CurrentActorDLDocRequest = new ActorDocRequest();
    this.CurrentActorDLDocRequest.EntryActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorDLDocRequest.ActorDocCode = ActorDocCode;
    this.CurrentActorDLDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorDLDocController = new Array<ActorDocController>();

    this.GetActorDLDocController();
  }
  CurrentActorDLDocRequest: ActorDocRequest;
  CurrentActorDLDocController: ActorDocController[];
  CurrentActorPPDocRequest: ActorDocRequest;
  CurrentActorPPDocController: ActorDocController[];
  /// gets all document pages of dl  
  GetActorDLDocController() {
    this.StartRefreshing();
    this.docservice.GetActorDocController(this.CurrentActorDLDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorDLDocController = this.ApiResData.Result;
          //this.initGridButton();
          this.stopRefreshing();

          this.LoadPassport();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  /// gets all document pages of  passport
  GetActorPPDocController() {
    this.StartRefreshing();
    this.docservice.GetActorDocController(this.CurrentActorPPDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorPPDocController = this.ApiResData.Result;
          //this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  //public DownloadActorDoc(ActorDocPageCode: number) {
  //  var DownloadActorDocPageCode = this.CurrentActorDocController.filter(x => x.ActorDocPageCode = ActorDocPageCode)

  //  if (DownloadActorDocPageCode.length > 0) {


  //    this.CurrentDownloadFileRequestRequest.DBFileName = DownloadActorDocPageCode[0].DocID; //"4e51623b-e1d8-49bf-aa23-a4ef4e9d1dc0";
  //    this.CurrentDownloadFileRequestRequest.folderType = "ActorDocuments"; //"patientDocuments";
  //    this.CurrentDownloadFileRequestRequest.ActorCode = DownloadActorDocPageCode[0].ActorCode;//35631;
  //    this.CurrentDownloadFileRequestRequest.FileExtension = DownloadActorDocPageCode[0].DocFileExtension   // '.pdf'
  //    this.CurrentDownloadFileRequestRequest.FriendlyFileName = DownloadActorDocPageCode[0].DocFriendlyName;
  //    // console.log('FileExtension-->'+this.CurrentDownloadFileRequestRequest.FileExtension);
  //    this.docservice.xDownloadDoc(this.CurrentDownloadFileRequestRequest)
  //  }
  //  else {
  //    alertFunctions.AlertParam("No file Exit...!");
  //  }


  //}

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start
  isREADONLY: boolean = false;
  exportFileName: string = "IdentitiesList_";
  dbops: DBOperation;
  columns: any[] = [
    {
      display: 'Identity Type',
      variable: 'CredentialType',
      filter: 'text',
    },
    {
      display: 'Identity Number',
      variable: 'CredentialNumber',
      filter: 'text'
    },
    {
      display: 'Issuing Authority',
      variable: 'IssuingAuthorityLongValue',
      filter: 'text'
    }
    //,
    //{
    //  display: 'Date of Birth',
    //  variable: 'DOB',
    //  filter: 'date'
    //}
  ];
  sorting: any = {
    column: 'CredentialType',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];
    this.gridbtns = [
      //{
      //  title: 'Edit',
      //  keys: ['ActorCredentialCode'],
      //  action: DBOperation.update,
      //  ishide: false
      //},
      {
        title: 'XX',
        keys: ["ActorCredentialCode"],
        action: DBOperation.delete,
        ishide: false
      },
      {
        title: 'Detail',
        keys: ["ActorCredentialCode"],
        action: DBOperation.detail,
        ishide: false
      },
      {
        title: 'Doc',
        keys: ["ActorDocCode"],
        action: DBOperation.doc,
        ishide: false
      },

    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {
      case DBOperation.create:
        this.openNewContent();
        break;
      case DBOperation.update:
       // alertFunctions.AlertParam('update' + gridaction.values[0].value);
        //  this.editUser(gridaction.values[0].value);
        break;
      case DBOperation.delete:
        //alertFunctions.AlertParam('delete');
        // this.DeleteActorIdentities(gridaction.values[0].value);
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteActorIdentities(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        })

        break;
      case DBOperation.detail:
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.detail:
        // alertFunctions.AlertParam('Details');
        // alertFunctions.AlertParam(gridaction.values[0].value);
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.doc:
        this.openDocContent(gridaction.values[0].value);
       
        break;
    }
  }

  /////////////////////////////////////////////////////////////////////////
  //

  // Open content with dark section
  openNewContent() {
    const modalRef = this.modalService.open(NgbIdentitiesinfoModal,
      {
        centered: true
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetActorDLDocController() })

  }

  //openNewDLContent() {

  //  const modalRef = this.modalService.open(NgbIdentitiesinfoModal,
  //    {
  //      centered: true
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetActorDLIdentitiesController() })


  //}

  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'

      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }

  public SaveActorIdentities() {
    this.actorservice.SaveActorIdentities(this.CurrentActorIdentitiesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');


            this.stopRefreshing();
            this.GetActorIdentitiesController();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  del_(ActorCredentialCode: any) {

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorCredentialCode);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorCredentialCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorIdentitiesRequest.ConditionalOperator = 3;
    this.CurrentActorIdentitiesRequest.ActorCredentialCode = ActorCredentialCode;
    this.actorservice.SaveActorIdentities(this.CurrentActorIdentitiesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');



            this.stopRefreshing();
            this.GetActorIdentitiesController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  OpenDetailContent(ActorCredentialCode: any) {

    var CurrentActorIdentitiesControllerByCode = this.CurrentActorIdentitiesController.filter(x => x.ActorCredentialCode === parseInt(ActorCredentialCode));
    if (CurrentActorIdentitiesControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbIdentitiesinfoModal,
        {
          centered: true
        })
      modalRef.componentInstance.IsShowDetail = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.CurrentActorIdentitiesControllerByCode = CurrentActorIdentitiesControllerByCode[0];


    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }

  OpenEditDL(l: any) {//ActorCredentialCode: any) {

    
    var CurrentActorIdentitiesControllerByCode = this.Dls.filter(x => x.ActorCredentialCode === (l.ActorCredentialCode));
    if (CurrentActorIdentitiesControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbIdentitiesinfoModal,
        {
          centered: true
        })
      modalRef.componentInstance.IsShowDl = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.CurrentActorIdentitiesControllerByCode = l;// CurrentActorIdentitiesControllerByCode[0];
      modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }


  OpenEditPassport(ActorCredentialCode: any) {

    var CurrentActorIdentitiesControllerByCode = this.CurrentActorIdentitiesController.filter(x => x.ActorCredentialCode === parseInt(ActorCredentialCode));
    if (CurrentActorIdentitiesControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbIdentitiesinfoModal,
        {
          centered: true
        })
      modalRef.componentInstance.IsShowPassport = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      //modalRef.componentInstance.PassportData = CurrentActorIdentitiesControllerByCode
      modalRef.componentInstance.CurrentActorIdentitiesControllerByCode = CurrentActorIdentitiesControllerByCode[0];
      modalRef.result.then(x => { this.GetActorIdentitiesController() })

    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
